import { usePersona } from '@/store/usePersona';
import { useTranslation } from 'react-i18next';

import { PERSONA_LABELS, PERSONA_ORDER, type Persona } from './types';
import styles from './PersonaSwitcher.module.css';

/**
 * Persona switcher — Axioma VII (persona = visual priority, not permission).
 * State persisted via Zustand+localStorage.
 */
export function PersonaSwitcher() {
  const { t } = useTranslation([
    'common',
    'nav',
    'board',
    'articles',
    'analytics',
    'feeddrive',
    'config',
    'strategist',
  ]);
  const persona = usePersona((s) => s.persona);
  const setPersona = usePersona((s) => s.setPersona);

  return (
    <label className={styles.root}>
      <span className={styles.hint}>{t('common:labels.view', 'Visão')}</span>
      <select
        className={styles.select}
        value={persona}
        onChange={(e) => setPersona(e.target.value as Persona)}
        aria-label={t('common:labels.switchPersona', 'Mudar persona ativa')}
      >
        {PERSONA_ORDER.map((p) => (
          <option key={p} value={p}>
            {PERSONA_LABELS[p]}
          </option>
        ))}
      </select>
    </label>
  );
}
